// extracted by mini-css-extract-plugin
export var hideEditor = "_i8-2";
export var infoIcon = "_i8-3";
export var label = "_i8-1";
export var labelContainer = "_i8-0";
export var readonlyText = "_i8-4";